import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const headers = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

export const sharedStockGroupsApi = {
  getAll: async () => {
    const response = await axios.get(`${API_URL}/api/admin/shared-stock-groups`, headers());
    return response.data;
  },
  create: async (data: { name: string; description?: string }) => {
    const response = await axios.post(`${API_URL}/api/admin/shared-stock-groups`, data, headers());
    return response.data;
  },
  delete: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/shared-stock-groups/${id}`, headers());
    return response.data;
  }
};
